"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewStudentsSelector = void 0;
var _hooks = require("../../../hooks");
var _AudiencePicker = require("../AudiencePicker.labels");
var _SliderLayout = require("../../../Layout/SliderLayout");
var _GroupName = require("./partials/GroupName");
var _SingleStudents = require("./partials/SingleStudents");
var _Error = require("./partials/Error");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var ViewStudentsSelector = function ViewStudentsSelector(props) {
  var setViewAndIndex = props.setViewAndIndex,
    viewIndex = props.viewIndex,
    createGroupTempData = props.createGroupTempData,
    saveGroup = props.saveGroup,
    onSelectedChanged = props.onSelectedChanged,
    selectedGroupsIds = props.selectedGroupsIds,
    selectedClassesIds = props.selectedClassesIds,
    studentsSelectorTempData = props.studentsSelectorTempData,
    selectedStudentsIds = props.selectedStudentsIds,
    _props$createGroupErr = props.createGroupErrorMessage,
    createGroupErrorMessage = _props$createGroupErr === void 0 ? '' : _props$createGroupErr;
  var getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  var hasChanges = (selectedStudentsIds === null || selectedStudentsIds === void 0 ? void 0 : selectedStudentsIds.length) !== (studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.selectedStudentsIds.length) || studentsSelectorTempData && studentsSelectorTempData.selectedStudentsIds.filter(function (id) {
    return selectedStudentsIds && selectedStudentsIds.indexOf(id) < 0;
  }).length > 0;
  var handleInputGroupNameConfirm = function handleInputGroupNameConfirm() {
    if (createGroupTempData && createGroupTempData.groupName && createGroupTempData.groupName.length > 0) {
      saveGroup('inline', 0, 'studentsSelector', 2, true);
    }
  };
  var handleInputGroupNameCancel = function handleInputGroupNameCancel() {
    setViewAndIndex('studentsSelector', 0);
  };
  var handleSingleStudentsCancel = function handleSingleStudentsCancel() {
    setViewAndIndex('inline', 0);
  };
  var handleSingleStudentsConfirm = function handleSingleStudentsConfirm() {
    if (hasChanges && onSelectedChanged) {
      onSelectedChanged({
        selectedGroupsIds: selectedGroupsIds,
        selectedClassesIds: selectedClassesIds,
        selectedStudentsIds: _toConsumableArray(studentsSelectorTempData && studentsSelectorTempData.selectedStudentsIds || [])
      });
    }
    setViewAndIndex('inline', 0);
  };
  var handleErrorGoBack = function handleErrorGoBack() {
    setViewAndIndex('studentsSelector', 1);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderLayout.SliderLayout, {
      width: "100%",
      index: viewIndex.studentsSelector,
      items: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleStudents.SingleStudents, _objectSpread(_objectSpread({}, props), {}, {
        onCancel: handleSingleStudentsCancel,
        onConfirm: handleSingleStudentsConfirm,
        isConfirmEnabled: hasChanges
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GroupName.GroupName, _objectSpread(_objectSpread({}, props), {}, {
        onCancel: handleInputGroupNameCancel,
        onConfirm: handleInputGroupNameConfirm
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.Error, _objectSpread(_objectSpread({}, props), {}, {
        title: getLabel(createGroupErrorMessage),
        subTitle: getLabel('create_group_error_sub_title'),
        onGoBack: handleErrorGoBack
      }))]
    })
  });
};
exports.ViewStudentsSelector = ViewStudentsSelector;